(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jdc-product-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select', (event) => {
    const accordion = event.target.querySelector('.jdc-product-accordions--block details');
    if (accordion) accordion.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jdc-product-character-portal"] && !Shopify.designMode) return;
  try {
    const initCharacterPortals = (scope = document) => {
    scope.querySelectorAll('[data-jdc-character-portal]').forEach((portal) => {
      if (portal.dataset.characterPortalReady === 'true') return;

      portal.dataset.characterPortalReady = 'true';

      const selectCharacter = (index, moveFocus = true) => {
        const profiles = Array.from(portal.querySelectorAll('[data-character-profile]'));
        const tabs = Array.from(portal.querySelectorAll('[data-character-tab]'));
        const activeProfile = profiles.find((profile) => profile.dataset.characterProfile === index);

        if (!activeProfile) return;

        profiles.forEach((profile) => {
          const isActive = profile === activeProfile;
          profile.hidden = !isActive;
          profile.classList.toggle('is-active', isActive);
        });

        tabs.forEach((tab) => {
          const isSelected = tab.dataset.characterTab === index;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        if (moveFocus) {
          const activeTab = activeProfile.querySelector(`[data-character-tab="${index}"]`);
          activeTab?.focus({ preventScroll: true });
        }
      };

      portal.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const tab = event.target.closest('[data-character-tab]');
        if (!tab || !portal.contains(tab)) return;

        selectCharacter(tab.dataset.characterTab);
      });

      portal.addEventListener('keydown', (event) => {
        if (!(event.target instanceof Element)) return;

        const tab = event.target.closest('[data-character-tab]');
        if (!tab) return;

        const tabList = tab.closest('[role="tablist"]');
        const tabs = Array.from(tabList.querySelectorAll('[data-character-tab]'));
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        selectCharacter(tabs[nextIndex].dataset.characterTab);
      });
    });
  };

  initCharacterPortals();
  document.addEventListener('shopify:section:load', (event) => initCharacterPortals(event.target));
  } catch(e) { console.error(e); }
})();

})();
